import { useAuth0 } from '@auth0/auth0-react';
import { useFlag } from '@unleash/proxy-client-react';
import { useEffect, useMemo, useRef } from 'react';
import { useIdleTimer, workerTimers } from 'react-idle-timer';
import { useGlobalState } from '../../data/Global.state';
import { getIdleLogoutMilliseconds } from '../../utils/idle-logout';

const IDLE_LOGOUT_CHANNEL_NAME = 'idle-logout';
const IDLE_LOGOUT_SYNC_TIMERS_MS = 1_000;

export function useIdleLogout() {
  const { isAuthenticated, logout } = useAuth0();
  const hasIdleLogoutFlag = useFlag('idle-logout');
  const { principal } = useGlobalState('principal');
  const logoutStartedRef = useRef(false);
  const principalId = principal?.principalId;
  const idleLogoutDurationMs = useMemo(
    () => (hasIdleLogoutFlag ? getIdleLogoutMilliseconds(principal?.settings?.idleLogoutDuration) : null),
    [hasIdleLogoutFlag, principal?.settings?.idleLogoutDuration],
  );
  const isDisabled = !isAuthenticated || !principalId || !idleLogoutDurationMs;

  useEffect(() => {
    logoutStartedRef.current = false;
  }, [isDisabled, idleLogoutDurationMs, principalId]);

  useIdleTimer({
    timeout: idleLogoutDurationMs ?? 1,
    disabled: isDisabled,
    crossTab: true,
    name: `${IDLE_LOGOUT_CHANNEL_NAME}:${principalId ?? 'anonymous'}`,
    syncTimers: IDLE_LOGOUT_SYNC_TIMERS_MS,
    timers: workerTimers,
    onIdle: () => {
      if (logoutStartedRef.current) {
        return;
      }

      logoutStartedRef.current = true;
      logout({ logoutParams: { returnTo: window.location.origin } });
    },
  });
}
